var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.largeHeader
    ? _c(
        "header",
        { attrs: { id: "header" } },
        [
          _c("GuideTour"),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "header-left-side" },
            [
              _c(
                "div",
                {
                  staticClass: "app-switcher-button",
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      return _vm.openAppSwitcher.apply(null, arguments)
                    },
                  },
                },
                [_c("i", { staticClass: "material-icons" }, [_vm._v("apps")])]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "company-logo",
                  on: {
                    click: function ($event) {
                      return _vm.chatMainMenu("/")
                    },
                  },
                },
                [_c("SupsisNewLogo")],
                1
              ),
              _vm._v(" "),
              !_vm.blockedConnection
                ? _c("ChatStats", { staticClass: "supsis-chat-stats" })
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c("Search", { staticClass: "supsis-search-bar" }),
          _vm._v(" "),
          _c("HeaderRight", {
            on: {
              getSupportActivityInfo: function ($event) {
                _vm.isLiveSupportActive = $event
              },
            },
          }),
          _vm._v(" "),
          _c(
            "a-modal",
            {
              attrs: {
                id: "make-bug-report",
                footer: null,
                title: _vm.$t("message.sendErrorFeedBack"),
                visible: _vm.errorModalVisible,
              },
              on: {
                cancel: function ($event) {
                  _vm.errorModalVisible = false
                },
                ok: function ($event) {
                  _vm.errorModalVisible = false
                },
              },
            },
            [
              _c("ErrorReport", {
                attrs: { "file-url": _vm.errorFileURl },
                on: {
                  changeVisibility: function ($event) {
                    _vm.errorModalVisible = false
                  },
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _vm.newVersionAvailable && !_vm.antModalExists()
            ? _c(
                "Modal2",
                {
                  attrs: {
                    visible: _vm.newVersionAvailable,
                    closable: true,
                    maskClosable: true,
                    okText: "Yeni Sürümü Yükle",
                    title: "Yeni Sürüm Mevcut",
                  },
                  on: {
                    ok: _vm.reloadPage,
                    cancel: function ($event) {
                      _vm.newVersionAvailable = false
                    },
                  },
                },
                [
                  _c(
                    "div",
                    { staticClass: "new-version-modal-content" },
                    [
                      _c("NewVersionUpdate", {
                        staticClass: "new-version-icon",
                      }),
                      _vm._v(" "),
                      _c("p", [
                        _vm._v(
                          "Yeni bir sürüm mevcut. Lütfen yeni sürüme geçmek için aşağıdaki butona tıklayın."
                        ),
                      ]),
                      _vm._v(" "),
                      _c("p", [
                        _vm._v(
                          "Mevcut Sürüm: " + _vm._s(_vm.versionInfo.versionStr)
                        ),
                      ]),
                    ],
                    1
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.appSwitcherVisible
            ? _c("AppSwitcher", {
                on: {
                  close: function () {
                    return (_vm.appSwitcherVisible = false)
                  },
                },
              })
            : _vm._e(),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }